<template lang="pug">
  .layout
    y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly")
      v-card
        v-card-title.px-5(:style="`background-color: ${$vuetify.theme.themes[$theme].basic600T16}`")
          v-row(no-gutters align="center")
            v-col.shrink
              v-btn.ml-n3(text icon @click="showModal = !showModal" height)
                v-icon(color="basic800" :size="24") mdi-close
            v-col.ml-3
              .h6.basic800--text {{ $t('edit_yezza_store') }}

        v-card-text.pa-0
          v-form(ref="form")
            v-card.pa-4(style="overflow-x: hidden;")
              .store-name
                label.mb-1.basic600--text.text-uppercase {{ $t('store_name.label') }}*
                v-text-field.mt-2(v-model='name' :placeholder="$t('store_name.placeholder')" outlined dense persistent-hint :rules="rules.not_empty" counter :maxlength="50" background-color="basic200")

              .store-description
                label.mb-1.basic600--text.text-uppercase {{ $t('store_description.label') }}
                v-textarea.mt-2(v-model='description' :placeholder="$t('store_description.placeholder')" outlined dense persistent-hint counter :maxlength="160" background-color="basic200")

              .store-photo.d-flex
                h6.basic1000--text {{ $t('store_photo') }}
                v-spacer
                div.file-layout(v-if="resizeProfileImageFileUrl")
                  v-btn.button-Aa-tiny.custom-transform-class.text-none.px-2(color="textColorAccent" text small)
                    eva-icon.mr-2(name="edit-outline" :fill="$vuetify.theme.themes[$theme].textColorAccent" height="12" width="12" style="margin-top: 1px")
                    | {{ $t('change_image') }}
                  input.input-layout(type="file" @change="onProfileFileChange" accept="image/*" style="width: 120px !important")

              v-card.my-3(outlined height="203" :style="{ 'background-color': $vuetify.theme.themes[$theme].basic200, 'border': '1px solid var(--v-primary200)' }")
                div.mt-9(v-if="resizeProfileImageFileUrl" align="center")
                  v-avatar.mx-auto(size="120px")
                    v-img(:src="resizeProfileImageFileUrl ? resizeProfileImageFileUrl : require('@/assets/image_placeholder.png')")
                div.fill-height(v-else)
                  div.d-flex.justify-center.align-end(style="height: 70%")
                    div
                      div.mb-2(align="center")
                        eva-icon(name="image-outline" :fill="$vuetify.theme.themes[$theme].primaryT32" height="38" width="38")
                      div.file-layout.mb-4
                        v-btn.button-AA-tiny(color="textColorAccent" outlined x-small height="24" :style="{'background-color': $vuetify.theme.themes[$theme].infoT08}") {{ $t('upload') }}
                        input.input-layout(type="file" @change="onProfileFileChange" accept="image/*" style="width: 60px !important")
                  div.d-flex.justify-center.align-end(style="height: 30%")
                    div.mb-4
                      div.c1.basic600--text.text-center {{ $t('max_image_filesize') }}
                      div.c1.basic600--text.text-center {{ $t('recommended_image_size') }}

              .cover-photo.d-flex.mt-6 
                h6.basic1000--text {{ $t('cover_photo') }}
                v-spacer
                div.file-layout(v-if="resizeImageFileUrl")
                  v-btn.button-Aa-tiny.custom-transform-class.text-none.px-2(color="textColorAccent" text small)
                    eva-icon.mr-2(name="edit-outline" :fill="$vuetify.theme.themes[$theme].textColorAccent" height="12" width="12" style="margin-top: 1px")
                    | {{ $t('change_image') }}
                  input.input-layout(type="file" @change="onFileChange" accept="image/*" style="width: 120px !important")
              v-card.my-3(outlined :height="resizeImageFileUrl ? '' : 203" :style="{ 'background-color': $vuetify.theme.themes[$theme].basic200 }")
                div(v-if="resizeImageFileUrl" align="center")
                  v-img(:src="resizeImageFileUrl" :aspect-ratio="16/9")
                div.fill-height(v-else)
                  div.d-flex.justify-center.align-end(style="height: 70%")
                    div
                      div.mb-2(align="center")
                        eva-icon(name="image-outline" :fill="$vuetify.theme.themes[$theme].primaryT32" height="38" width="38")
                      v-divider
                      div.file-layout.mb-4
                        v-btn.button-AA-tiny(color="textColorAccent" outlined x-small height="24" :style="{'background-color': $vuetify.theme.themes[$theme].infoT08}") {{ $t('upload') }}
                        input.input-layout(type="file" @change="onFileChange" accept="image/*" style="width: 60px !important")
                  div.d-flex.justify-center.align-end(style="height: 30%")
                    div.mb-4
                      div.c1.basic600--text.text-center {{ $t('max_image_filesize') }}
                      div.c1.basic600--text.text-center {{ $t('recommended_image_size') }}

              h6.basic1000--text.mt-6 {{ $t('seo') }}
              div.mt-2.c1.primary400--text {{ $t('seo_subheader') }}
              v-row.mt-4
                v-col.py-0
                  .meta-title
                    label.basic600--text.text-uppercase {{ $t('meta_title') }}
                    v-text-field.mt-3(v-model='metaTitle' :placeholder="name" outlined dense :maxlength="100" background-color="basic200")
              v-row
                v-col.py-0
                  .meta-description
                    label.basic600--text.text-uppercase {{ $t('meta_description') }}
                    v-textarea.mt-3(v-model='metaDescription' :placeholder="description" outlined dense :maxlength="200" background-color="basic200" hide-details)
                    .guide.mt-3.d-flex
                      eva-icon.mr-2(name="info-outline" :fill="$vuetify.theme.themes[$theme].basic600" height="15" width="15")
                      div.c1.basic600--text {{ $t('meta_keywords_note') }} 
                        a.text-decoration-none.textColorAccent--text(href="https://webmasters.googleblog.com/2009/09/google-does-not-use-keywords-meta-tag.html" target="_blank") {{ $t('meta_keywords_ref') }}

        v-card-actions
          v-spacer
          v-btn(color='white', text @click='showModal = false')
            .button-Aa-medium.primary400--text {{ $t('cancel') }}
          v-btn.mr-2(color='info500' dark depressed height=32 @click="clickSave" :loading="isLoading")
            .button-AA-medium.basic100--text {{ $t('save') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { resizeImage } from '@/utils'

export default {
  name: 'EditYezzaStoreDialog',
  props: ['open', 'settings'],
  data: () => ({
    name: '',
    description: '',
    metaTitle: '',
    metaDescription: '',
    resizeProfileImageFileUrl: '',
    resizeProfileImageFile: null,
    resizeImageFileUrl: '',
    resizeImageFile: null,
    isLoading: false,
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required']
    }
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  mounted () {
    this.name = this.settings.name
    this.description = this.settings.description
    this.metaTitle = this.settings.meta_title
    this.metaDescription = this.settings.meta_description
    if (this.settings.profile_image) {
      this.resizeProfileImageFileUrl = this.settings.profile_image.file
    }
    if (this.settings.cover_image) {
      this.resizeImageFileUrl = this.settings.cover_image.file
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    clickSave() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      var params = new FormData();
      params.set('company', this.company.id)
      params.set('name', this.name)
      params.set('description', this.description || '')
      params.set('meta_title', this.metaTitle || '')
      params.set('meta_description', this.metaDescription || '')
      if (this.resizeProfileImageFile) {
        params.append('profile_image', this.resizeProfileImageFile)
      }
      if (this.resizeImageFile) {
        params.append('cover_image', this.resizeImageFile)
      }
      this.axios.patch(`/store/settings/${this.company.slug}/`, params)
        .then(resp => {
          this.showModal = false
          this.showMessage(['success', this.$t('success_message.store_edited')])
          this.$emit('update:settings', resp.data)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    async onProfileFileChange (e) {
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) { return }
      const file = files[0]
      const resizedImage = await resizeImage(file, 'profile_image.jpeg')
      this.resizeProfileImageFileUrl = resizedImage.dataURL
      this.resizeProfileImageFile = resizedImage.file
    },
    async onFileChange (e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) { return }
      const resizedImage = await resizeImage(files[0], 'cover_image.jpeg')
      this.resizeImageFileUrl = resizedImage.dataURL
      this.resizeImageFile = resizedImage.file
    }
  }
}
</script>

<style scoped>
.file-layout {
  position: relative;
}
.input-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "store_photo": "Store Photo",
    "cover_photo": "Cover Photo",
    "upload": "Upload",
    "edit": "Edit",
    "details": "Details",
    "store_name": {
      "label": "Name",
      "placeholder": "Write your store name here"
    },
    "store_description": {
      "label": "Description",
      "placeholder": "Write your store description here"
    },
    "price": {
      "label": "Price",
      "placeholder": "0"
    },
    "weight": {
      "label": "Weight",
      "placeholder": "Min = 0.1 kg | Max = 60 kg"
    },
    "description": {
      "label": "Description",
      "placeholder": "Write product description here"
    },
    "seo": "Search Engine Optimization (SEO)",
    "seo_subheader": "This is SEO for home page only. For product page, edit in individual product settings.",
    "meta_title": "Meta Title",
    "meta_description": "Meta Description",
    "meta_keywords_note": "Note: Meta keywords is not supported.",
    "meta_keywords_ref": "More info here.",
    "show_soldout": "Show Sold Out",
    "hide_soldout": "Hide Sold Out",
    "quantity": {
      "label": "Quantity",
      "placeholder": "How many stock left"
    },
    "whos_selling": "Who's Selling",
    "edit_yezza_store": "Edit Yezza Store"
  },
  "id": {
    "store_photo": "Foto Toko",
    "cover_photo": "Foto Sampul",
    "upload": "Unggah",
    "edit": "Edit",
    "details": "Detail",
    "store_name": {
      "label": "Nama",
      "placeholder": "Tulis nama toko kamu di sini"
    },
    "store_description": {
      "label": "Deskripsi",
      "placeholder": "Tulis Deskripsi toko di sini"
    },
    "price": {
      "label": "Harga",
      "placeholder": "0"
    },
    "weight": {
      "label": "Berat",
      "placeholder": "Min = 0.1 kg | Max = 60 kg"
    },
    "description": {
      "label": "Deskripsi",
      "placeholder": "Tulis Deskripsi produk di sini"
    },
    "seo": "Search Engine Optimization (SEO)",
    "seo_subheader": "Ini SEO untuk halaman utama saja. Halaman untuk produk, dapat diedit pada pengaturan produk individual.",
    "meta_title": "Meta Title",
    "meta_description": "Meta Description",
    "meta_keywords_note": "Note: Meta keywords is not supported.",
    "meta_keywords_ref": "More info here.",
    "show_soldout": "Tampilkan produk terjual habis",
    "hide_soldout": "Sembunyikan produk terjual habis",
    "quantity": {
      "label": "Kuantitas",
      "placeholder": "Berapa stok tersisa"
    },
    "whos_selling": "Penjual",
    "edit_yezza_store": "Edit Toko"
  }
}
</i18n>
